import { Typography } from 'components/common'
import ThreadListItem, { TThreadListItem } from './ThreadListItem'
import useCategoryThreads from './useCategoryThreads'
import InfiniteList from 'components/InfiniteList'
import { faMessages } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import useThreadInputModal from './useThreadInputModal'
import BaseCategoryHeader from './BaseCategoryHeader'
import ForumWrapper from './ForumWrapper'
import { useForumContext } from './ForumContext'
import {
  useCategoryChangedSubscription,
  useThreadAddedSubscription,
  useThreadPinnedSubscription
} from 'graphql/generated'

const Threads: React.FC = () => {
  const { selectedCategory, selectedCategoryId, refetchBoard } =
    useForumContext()

  const { threads, loading, loadMore, loadingMore, refetch } =
    useCategoryThreads(selectedCategoryId)

  useCategoryChangedSubscription({
    variables: {
      categoryId: selectedCategoryId
    },
    onData: () => {
      refetchBoard()
    }
  })

  useThreadPinnedSubscription({
    variables: {
      categoryId: selectedCategoryId
    },
    onData: () => {
      refetch()
    }
  })

  useThreadAddedSubscription({
    variables: {
      categoryId: selectedCategoryId
    },
    onData: () => {
      refetch()
    }
  })

  const { modalTrigger: newThreadTrigger } = useThreadInputModal({})

  return (
    <InfiniteList<TThreadListItem['thread']>
      className="pb-2"
      items={threads}
      renderItem={(thread, index) => (
        <ThreadListItem thread={thread} key={index} />
      )}
      emptyText={
        <div className="mt-4 h-48 flex flex-col gap-4 items-center justify-center">
          <FontAwesomeIcon
            icon={faMessages}
            size="5x"
            className="text-gray-300"
          />
          <Typography color="lightGray">{`Looks like there's no threads yet`}</Typography>

          {!selectedCategory.archived && newThreadTrigger}
        </div>
      }
      loadMore={loadMore}
      loading={loading}
      loadingMore={loadingMore}
    />
  )
}

const Forum: React.FC = () => {
  return (
    <ForumWrapper>
      <BaseCategoryHeader />
      <Threads />
    </ForumWrapper>
  )
}

export default Forum
